import React, { useState, useEffect } from "react";
// import toast from 'react-hot-toast';
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import DataTable from "react-data-table-component";
import { useNavigate } from "react-router-dom";

//Redux
import { useSelector, useDispatch } from "react-redux"; //useDispatch

//Serivce
import ItemService from "../../../../services/supplier_appCommonService";

//Components
import Layout from "../../../../Layout/Layout";
// import CreateSupplierMasterModal from "../../../../Components/Modal/supplier_app/CreateSupplierMasterModal";
import Constants from "../../../../common/SupplierConstants";
import CommonItemLevelDatatableModal from "../../../../Components/Modal/supplier_app/CommonItemLevelDatatableModal";
// import {
//   // addsupplierID,
//   getSupplierList,
//   // workflow,
// } from "../../../../redux/feature/supplier_app/supplierSlice";
import CommonFillter from "../../../../Components/Filter/Supplier/SupplierCommonFillter";
import ShowStatus from "../../../../Components/Modal/supplier_app/Workflow/ShowStatus";
import {
  formatDate,
  formatDateTime,
  getContactDetails,
} from "../../../../common/Validations";
import { SearchField } from "../../../../Components/formElements/SearchField";
import SuccessModal from "../../../../Components/Modal/supplier_app/SuccessModal";
import CreateInviteSupplierModal from "../../../../Components/Modal/supplier_app/CreateInviteSupplierModal";
import ConfirmSendInvitationModel from "../../../../Components/Modal/supplier_app/ConfirmSendInvitationModel";
import ConfirmationLoader from "../../../../Components/ConfirmationLoader";
import BroadcastModel from "../../../../Components/Modal/supplier_app/BroadcastModel";
import SupplierDeactivateModel from "../../../../Components/Modal/supplier_app/SupplierDeactivateModel";
// import StatusCountForList from "../../../../Components/StatusCountForList";
import { TableStatusField } from "../../../../Components/formElements/TableStatusField";
import CustomerConstants from "../../../../common/CustomerConstants";
import FileViewerModal from "../../../../Components/FileViewer/FileViewerModal";
import { INVITE_LINKS } from "../CustomerV5Constant/MRSupplierConstant";
// import DownloadVendorTemplateMR from "./BulkUpload/DownloadVendorTemplateMR";
// import VendorBulkUploadModalMR from "./BulkUpload/VendorBulkUploadModalMR";
import MultiColumnFilter from "../../../../Components/MultiColumnFilter/MultiColumnFilter";
import {
  getMRUserList,
  setMRUserMasterId,
} from "../../../../redux/feature/customer_app/customerSlice";

const UserRegistrationListMR = () => {
  // eslint-disable-next-line no-unused-vars
  const dispatch = useDispatch();
  const navigate = useNavigate();
  localStorage.setItem("menu", "Master");
  localStorage.setItem("submenu", "Hospital-Patient-Nurse");
  let supplierData = useSelector((state) => state?.customer?.mrUserList); // User Details from Store
  let supplierTable = useSelector((state) => state?.customer?.mrUserList?.pagination); // User Details from Store
  let config = useSelector((state) => state?.common?.data?.suppliers); // User Details from Store

  const [data, setData] = useState([]);
  // console.log(">>data", data)

  const [isCardVisible, setCardVisible] = useState(true);
  // const [modalShow, setModalShow] = useState(false);
  const [modalShowStatus, setModalShowStatus] = useState(false);
  // eslint-disable-next-line
  const [sendDataModal, setSendDataModal] = useState("");
  // eslint-disable-next-line
  const [modelTitle, setModelTitle] = useState("");

  const [getItemLevelData, setItemLevelData] = useState([]);
  const [getItemLevelColumns, setItemLevelColumns] = useState([]);
  const [getModalTitle, setModalTitle] = useState("");
  const [itemLevelModalShow, setItemLevelModalShow] = useState(false);

  const [getAccountGroup, setAccountGroup] = useState([]);
  // eslint-disable-next-line
  const [getNewPerPage, setNewPerPage] = useState(100);
  const [getCommonSearchTxt, setCommonSearchTxt] = useState("");

  const [isPageLoading, setIsPageLoading] = useState(false); // Loading state
  const [selectedRows, setSelectedRows] = useState([]);
  // eslint-disable-next-line
  const [statusCountData, setStatusCountData] = useState([]);

  /* pop success modal */
  const [getShowSuccessModal, setShowSuccessModal] = useState(false);
  const successModalData = {
    title: "Success",
    successMsg: "",
  };
  const [getsucceModalData, setsucceModalData] = useState(successModalData);
  const [getShowSupplierInviteModal, setShowSupplierInviteModal] =
    useState(false);
  const [getShowSendInvitationModal, setShowSendInvitationModal] =
    useState(false);
  const [getShowhideBroadcastModel, setShowhideBroadcastModel] =
    useState(false);
  const [getShowSupplierDeactivateModel, setShowSupplierDeactivateModel] =
    useState(false);
  const [filterShow, setFilterShow] = useState(false);

  const onSuccessmodel = () => setShowSuccessModal(true);
  const hideSuccessModal = () => setShowSuccessModal(false);
  const hideSupplierInviteModal = () => setShowSupplierInviteModal(false);
  const hideSendInvitationModal = () => setShowSendInvitationModal(false);
  const hideBroadcastModel = () => setShowhideBroadcastModel(false);
  const hideSupplierDeactivateModel = () =>
    setShowSupplierDeactivateModel(false);
  const handleRowSelect = ({ selectedRows }) => {
    setSelectedRows(selectedRows);
  };
  const sendInvitation = async () => {
    if (selectedRows.length === 0) {
      // alert("Please select at least one row.")
      successModalData.title = "Error";
      successModalData.successMsg = "Please select at least one row.";
      setsucceModalData(successModalData);
      onSuccessmodel();
      return;
    }
    try {
      setIsPageLoading(true); // Start loading
      const emailIds = selectedRows.map((row) => row.email);
      let obj = {
        email: emailIds,
      };
      // console.log("obj", obj);
      await ItemService.sendInvitation(obj).then((item) => {
        // console.log(">> item!", item);
        if (item?.status === 200) {
          successModalData.successMsg = item?.message;
          setsucceModalData(successModalData);
          onSuccessmodel();
        } else {
        }
      });
    } catch (error) {
      console.log("Failed to send invitaion:", error);
    } finally {
      setIsPageLoading(false); // End loading
    }
  };
  const handleBroadcast = async (payload) => {
    try {
      setIsPageLoading(true); // Start loading
      const emailIds = selectedRows.map((row) => row.email);
      let obj = {
        email: emailIds,
        broadcastRemark: payload?.broadcastRemark,
      };
      // console.log("obj", obj);
      await ItemService.supplierBroadcast(obj).then((item) => {
        // console.log(">> item!", item);
        if (item?.status === 200) {
          successModalData.successMsg = item?.message;
          setsucceModalData(successModalData);
          onSuccessmodel();
        } else {
        }
      });
    } catch (error) {
      console.log("Failed to Broadcast:", error);
    } finally {
      setIsPageLoading(false); // End loading
    }
  };
  const handleDeactivateSupplier = async (payload) => {
    try {
      setIsPageLoading(true); // Start loading
      const supplierIds = selectedRows.map((row) => row.userId);
      let obj = {
        supplierIds: supplierIds,
        remark: payload?.remark,
      };
      // console.log("obj", obj);
      await ItemService.supplierDeactivate(obj).then((item) => {
        // console.log(">> item!", item);
        if (item?.status === 200) {
          successModalData.successMsg = item?.message;
          setsucceModalData(successModalData);
          onSuccessmodel();
        } else {
        }
      });
    } catch (error) {
      console.log("Failed to De-activate:", error);
    } finally {
      setIsPageLoading(false); // End loading
    }
  };
  const inviteSupplier = async (formData) => {
    setIsPageLoading(true); // Start loading
    try {
      const payload = {
        ...formData,
        registrationLink: INVITE_LINKS.registrationLink,
      };
      await ItemService.inviteSupplier(payload).then((item) => {
        if (item?.status === 200) {
          // console.log("item", item);
          successModalData.successMsg = item?.message;
          setShowSuccessModal(true);
          setsucceModalData(successModalData);
          onSuccessmodel();
        } else {
          console.error("Failed to send invitation:");
        }
      });
    } catch (error) {
      console.log("Failed to send invitaion:", error);
    } finally {
      setIsPageLoading(false); // End loading
    }
  };
  const detailedPage = (supplierID, workflowActionLogs) => {
    // dispatch(addsupplierID(supplierID));
    dispatch(setMRUserMasterId(supplierID));

    // dispatch(workflow(workflowActionLogs));
    // navigate(Constants.SUPPLIER_DETAILED_PAGE_CREATE);
    navigate(CustomerConstants.CUSTOMER_V5_MR_USER_DETAILS);
  };

  const itemLevelHideModal = () => {
    setItemLevelModalShow(false);
  };
  // OnClick on categoryItem  Data

  // OnClick on Certificate document Data
  const certificateDocumentShowModal = (itemLevelData) => {
    setItemLevelData(itemLevelData);
    setItemLevelColumns(certificateDocumentColInfo);
    setModalTitle("Certificate document Details");
    setItemLevelModalShow(true);
  };

  const toggleCardVisibility = () => {
    setCardVisible(!isCardVisible);
  };

  const [getShowFileViewModal, setShowFileViewModal] = useState(false);
  const [getFileViewData, setFileViewData] = useState(null);

  // View attachment files
  const handleViewFile = (fileAttachmentId) => {
    setFileViewData(fileAttachmentId);
    setShowFileViewModal(true);
  };
  const handleViewFileHide = () => {
    setShowFileViewModal(false);
  };

  useEffect(() => {
    setData(supplierData?.data);
  }, [supplierData]);

  useEffect(() => {
    let obj = {
      queryName: "getSupplierList",
      module: "",
      page: 1,
      per_page: 100,
      rowFilter: {
        $and: [
          {
            "vendorCategory.vendorCategoryCode": {
              $in: ["V04", "V11", "V12", "V13", "V14"],
            },
          },
        ],
      },
      timeZone: "Asia/Calcutta",
    };
    dispatch(getMRUserList(obj));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handlePageChange = (page) => {
    let obj = {
      queryName: "getSupplierList",
      module: "",
      page: page,
      per_page: getNewPerPage,
      // chartCategory: "status",
      // rowFilter: {
      //   $and: [
      //     {
      //       customerTypeCode: "S01",
      //     },
      //   ],
      // },
      rowFilter: {
        $and: [
          {
            "vendorCategory.vendorCategoryCode": {
              $in: ["V04", "V11", "V12", "V13", "V14"],
            },
          },
        ],
      },
    };

    // dispatch(getSupplierList(obj));
    dispatch(getMRUserList(obj));
  };

  const handlePerRowsChange = async (newPerPage, page) => {
    let obj = {
      // queryName: "getSupplier_StatusChartList",
      queryName: "getSupplierList",
      module: "",
      page: page,
      per_page: newPerPage,
      // chartCategory: "status",
      // rowFilter: {
      //   $and: [
      //     {
      //       customerTypeCode: "S01",
      //     },
      //   ],
      // },
      rowFilter: {
        $and: [
          {
            "vendorCategory.vendorCategoryCode": {
              $in: ["V04", "V11", "V12", "V13", "V14"],
            },
          },
        ],
      },
    };
    setNewPerPage(newPerPage);
    // dispatch(getSupplierList(obj));
    dispatch(getMRUserList(obj));
  };

  // Common Search Function on button
  const handleSearchFuncApi = async () => {
    let obj = {
      queryName: "getSupplierList",
      rowFilter: {
        $and: [
          {
            "vendorCategory.vendorCategoryCode": {
              $in: ["V04", "V11", "V12", "V13", "V14"],
            },
          },
        ],
      },
      page: 1,
      per_page: 100,
      searchTerm: getCommonSearchTxt,
    };
    // dispatch(getSupplierList(obj));
    dispatch(getMRUserList(obj));
  };

  // eslint-disable-next-line
  const loadTotalStatusCount = async () => {
    let obj = {
      // queryName: "getSupplier_StatusChartList",
      // chartCategory: "status",
      // rowFilter: {
      //   $and: [
      //     {
      //       customerTypeCode: "S01",
      //     },
      //   ],
      // },
    };
    try {
      await ItemService.generateChartQuery(obj).then((item) => {
        // console.log(">> item.data", item?.data);

        if (item?.status === 200) {
          setStatusCountData(item?.data);
        } else {
          console.error("Failed to Status Count");
        }
      });
    } catch (error) {
      console.log("Failed to Status Count", error);
    }
  };

  // On page load
  // useEffect(() => {
  //   let obj = {
  //     queryName: "getSupplier_StatusChartList",
  //     module: "",
  //     page: 1,
  //     per_page: 10,
  //     timeZone: "Asia/Calcutta",
  //   };

  //   console.log(">> Initial API Call Payload:", obj);
  //   // dispatch(getSupplierList(obj));
  //   dispatch(getMRUserList(obj));

  //   getMasterData();
  //   loadTotalStatusCount();
  //   // eslint-disable-next-line react-hooks/exhaustive-deps
  // }, []);

  const columns = [
    {
      name: "Profile",
      width: "80px",
      cell: (row) => (
        <img
          src="assets/img/profile-img.png"
          alt="Profile"
          className="rounded-circle profileImageCss"
          style={{ width: "40px" }}
        />
      ),
    },
    {
      name: "ID",
      selector: (row) => row.userId || "--",
      sortable: true,
      cell: (row) => (
        <button
          className="btnInfo"
          onClick={() => detailedPage(row.userId, row.workflowActionLogs)}
        >
          {row.userId || "-"}{" "}
        </button>
      ),
      width: "120px",
    },
    {
      name: "Category",
      cell: (row) => (
        <>
          {/* <span>{row.vendorCategory || "--"}</span> */}
          <TableStatusField
            status={
              row.vendorCategory[0].vendorCategoryName ||
              row.vendorCategory[0].vendorCategoryDescription ||
              row.vendorCategory[0].vendorCategoryDesc
            }
          />
        </>
      ),
      selector: (row) => row.vendorCategory || "--",
      sortable: false,
      width: "150px",
    },
    {
      name: "User Name",
      cell: (row) => (
        <>
          <span className="m-0 p-0 pt-1 fw-bold">{row.organisationName}</span>
        </>
      ),
      selector: (row) => row.organisationName,
      sortable: true,
      width: "180px",
    },
    {
      name: "Status",
      cell: (row) => (
        <TableStatusField status={row.activeInactive ? "Active" : "Inactive"} />
      ),
      width: "130px",
    },
    {
      name: "Contact Details",
      cell: (row) => (
        <>
          <div>
            <p className="m-0 p-0 fw-medium">
              {getContactDetails(row)?.contactNumber || row?.mobileNr}
            </p>
            <p className="m-0 p-0">
              {getContactDetails(row)?.contactEmail || row?.email}
            </p>
          </div>
        </>
      ),
      sortable: true,
      width: "250px",
    },
    {
      name: "Contact Person",
      cell: (row) => (
        <>
          <span>{row.contactDetails[0]?.contactName || "--"}</span>
        </>
      ),
      selector: (row) => row.contactDetails[0]?.contactName || "--",
      sortable: true,
      width: "180px",
    },
    {
      name: "Certificates ",
      cell: (row) => (
        <>
          <span
            style={{ marginLeft: "12px" }}
            onClick={() => certificateDocumentShowModal(row.certifications)}
          >
            <i className="bi bi-calendar2-week iconTable"></i>
          </span>
          <span className="suppliersIcon">
            {" "}
            {row.certifications?.length > 0
              ? row.certifications?.length
              : "0"}{" "}
          </span>
        </>
      ),
      width: "150px",
    },
    {
      name: "Created By/Date",
      selector: (row) => formatDateTime(row.createdAt),
      cell: (row) => (
        <>
          <div>
            <p className="m-0 p-0 fw-medium">{row?.createdBy}</p>
            <p className="m-0 p-0 ">{formatDateTime(row.createdAt)}</p>
          </div>
        </>
      ),
      sortable: true,
      width: "160px",
    },
    {
      name: "Sales Officer",
      selector: (row) => row?.salesOfficerName,
      cell: (row) => (
        <>
          <div>
            <p className="m-0 p-0 fw-medium">{row?.salesOfficerName}</p>
            <p className="m-0 p-0 ">{row?.salesOfficerCode}</p>
          </div>
        </>
      ),
      sortable: true,
      width: "160px",
    }, 
    {
      name: "Company",
      cell: (row) => (
        <>
          <span> {row.companyCode} </span>
        </>
      ),
      sortable: true,
      width: "180px",
    },
  ];

  const filterColumns = [
    {
      id: "companyCode",
      name: "Company",
      selectorKey: "companyCode",
    },
    {
      id: "city",
      name: "City",
      selectorKey: "city",
    },
    {
      id: "contactNumber",
      name: "Contact Number",
      selectorKey: "contactNumber",
      nestedArray: true,
      nestedPath: "contactDetails",
    },
    
    {
      id: "address",
      name: "Address",
      selectorKey: "address",
      combined: true,
      combinedFields: ["address", "address2"],
    },
  ];

  //  Handle multi-column filter
  const handleMultiColumnFilter = (filterResult) => {
    // setFilterShow(false);

    let obj = {
      // queryName: "getSupplier_StatusChartList",
      queryName: "getSupplierList",
      module: "",
      page: 1,
      per_page: 100,
      searchTerm: getCommonSearchTxt || "",
      timeZone: "Asia/Calcutta",
    };

    // // Add filter if exists
    // if (filterResult && filterResult.$and && filterResult.$and.length > 0) {
    //   obj.rowFilter = filterResult;
    // }

    obj.rowFilter = {
      $and: [
        //  DEFAULT (V04, V11 ONLY)
        {
          "vendorCategory.vendorCategoryCode": {
            $in: ["V04", "V11", "V12", "V13", "V14"],
          },
        },
        //  USER FILTERS (MERGED)
        ...(filterResult?.$and || []),
      ].filter(Boolean), // Remove empty
    };

    dispatch(getMRUserList(obj));
  };

  //  Handle filter cancel
  const handleFilterCancel = () => {
    setFilterShow(false);
  };

  const certificateDocumentColInfo = [
    {
      name: "Certificate Type",
      cell: (row) => <span>{row.documentType} </span>,
      width: "180px",
    },
    {
      name: "Certificate Number",
      cell: (row) => <span>{row.documentNumber} </span>,
      width: "180px",
    },
    {
      name: "Issuing Date",
      cell: (row) => <span>{formatDate(row.issueDate)} </span>,
      width: "180px",
    },
    // {
    //   name: "Issueing Authority/Accreditation",
    //   cell: (row) => <span>{row.issuingAuthority} </span>,
    //   width: "180px",
    // },

    // {
    //   name: "Certificate Attachement",
    //   cell: (row) => <span>{row.certificateAttachement} </span>,
    //   width: "180px",
    // },
    {
      name: "Certificate Attachment",
      cell: (row) => (
        <div className="d-flex justify-content-center">
          {row.iSOCertification ? (
            <img
              src="assets/img/newIcons/attached-file.png"
              className="mt-1 attachmentIcon"
              alt="attachments"
              onClick={() => handleViewFile(row.iSOCertification)}
            />
          ) : (
            "--"
          )}
        </div>
      ),
      width: "180px",
    },
  ];

  // eslint-disable-next-line
  const getMasterData = async () => {
    let obj = {
      codeType: "accountGroup",
    };
    await ItemService.getMasterData(obj).then((item) => {
      // console.log('>> item!',item);
      if (item?.status === 200) {
        setAccountGroup(item?.data);
      } else {
        setAccountGroup([]);
        console.log(">> Error: Loading getMasterData");
      }
    });
  };

  const hideModalStatus = () => {
    setModalShowStatus(false);
  };
  const supplierCreate = () => {
    // console.log(">>auctionNr",auctionNr?.documentNumber)
    // dispatch(addauctionNr(auctionNr?.documentNumber));
    // navigate(CustomerConstants.SUPPLIER_MASTER_CREATE_SV);
    navigate(CustomerConstants.CUSTOMER_V5_MR_USER_REGISTRATION);
  };

  return (
    <main className="dashboard main" id="main">
      {/* Spinner Overlay */}
      <ConfirmationLoader isPageLoading={isPageLoading} />
      <Layout />
      <Row className="justify-center subContent">
        <Col xs={12} md={12} className="rightSide">
          <div className="rightSideInner PageCommonCSS">
            <Row>
              <Col xs={12} md={8} lg={8}>
                <h2 className="mainTitle">Hospital / Doctors / Nursing / Patient User List</h2>
                <p className="subText"> Directory and Overview </p>
              </Col>
              <Col xs={12} md={3} lg={3} className="mt-3">
                <SearchField
                  name="searchKey"
                  value={getCommonSearchTxt}
                  onChange={(event) => setCommonSearchTxt(event.target.value)}
                  onClick={() => handleSearchFuncApi()}
                />
              </Col>
              <Col xs={4} md={1} lg={1}>
                <span
                  className="filterIcon"
                  onClick={() => setFilterShow(!filterShow)}
                >
                  <i class="bi bi-filter"></i>
                </span>
              </Col>
            </Row>
            <hr />
            <Row>
              <Col xs={12} md={12} lg={12}>
                {filterShow && (
                  <MultiColumnFilter
                    columns={filterColumns}
                    data={data || []} //  Pass current User data for dropdown options
                    onFilter={handleMultiColumnFilter}
                    onCancel={handleFilterCancel}
                    output="and" //  Returns { $and: [...] } format
                  />
                )}
              </Col>
            </Row>
            <hr />
            
            

            <div className="accordion" id="accordionExample">
              <div className="accordion-item">
                <h2 className="accordion-header">
                  <Row className="accordion-button">
                    <Col xs={1} md={1} lg={1} className="text-left arrowBtn">
                      <i
                        className={`bi ${
                          isCardVisible ? "bi-chevron-right" : "bi-chevron-down"
                        }`}
                        onClick={toggleCardVisibility}
                      ></i>
                    </Col>
                    <Col xs={1} md={1} lg={1} className="text-center logoBtn">
                      <span className="iconLogo">UL</span>
                    </Col>
                    <Col xs={7} md={8} lg={8}>
                      <span className="headerTitle">Hospital/Doctor/Patient/Nursing List</span>
                      <span className="subHeaderTitle">
                        View of Hospital, Doctor, Patient and Nursing list and Status{" "}
                      </span>
                    </Col>

                    <Col xs={2} md={2} lg={2} className="">
                      <button
                        className="btnTable"
                        onClick={() => supplierCreate(true)}
                      >
                        + Add User
                      </button>
                    </Col>

                    {config?.filter && (
                      <Col xs={2} md={1} lg={1} className="">
                        <CommonFillter />
                      </Col>
                    )}
                  </Row>
                </h2>

                <div
                  // id="acc"
                  className={`accordion-collapse collapse show ${
                    isCardVisible ? "visible" : ""
                  }`}
                  // aria-labelledby="headingOne"
                  // data-bs-parent="#accordionExample"
                >
                  <div className="accordion-body">
                    <Row>
                      <Col xs={12} md={12} lg={12}>
                        <DataTable
                          title=""
                          columns={columns}
                          data={data}
                          progressPending={supplierData?.status}
                          paginationRowsPerPageOptions={Constants.ROW_REPORT_PER_PAGE}
                          pagination
                          paginationServer
                          paginationTotalRows={supplierTable.total}
                          onChangeRowsPerPage={handlePerRowsChange}
                          onChangePage={handlePageChange}
                          onSelectedRowsChange={handleRowSelect}
                          selectableRows
                        />
                      </Col>
                    </Row>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </Col>
      </Row>

      {/* <CreateSupplierMasterModal
        show={modalShow}
        onHide={() => hideModal()}
      /> */}

      <CommonItemLevelDatatableModal
        show={itemLevelModalShow}
        onHide={() => itemLevelHideModal()}
        columns={getItemLevelColumns}
        data={getItemLevelData}
        title={getModalTitle}
        dropdownData={getAccountGroup}
      />

      <ShowStatus
        show={modalShowStatus}
        onHide={() => hideModalStatus()}
        rowdatamodal={sendDataModal}
        modeltitle={modelTitle}
      />
      <SuccessModal
        show={getShowSuccessModal}
        onHide={() => hideSuccessModal()}
        successmodaldata={getsucceModalData}
      />
      <CreateInviteSupplierModal
        show={getShowSupplierInviteModal}
        onHide={hideSupplierInviteModal}
        onSubmit={inviteSupplier}
      />
      <ConfirmSendInvitationModel
        show={getShowSendInvitationModal}
        onHide={hideSendInvitationModal}
        onSubmit={sendInvitation}
        selectedRows={selectedRows}
      />
      <BroadcastModel
        show={getShowhideBroadcastModel}
        onHide={hideBroadcastModel}
        onSubmit={handleBroadcast}
        selectedRows={selectedRows}
      />
      <SupplierDeactivateModel
        show={getShowSupplierDeactivateModel}
        onHide={hideSupplierDeactivateModel}
        onSubmit={handleDeactivateSupplier}
        selectedRows={selectedRows}
      />
      <FileViewerModal
        show={getShowFileViewModal}
        onHide={handleViewFileHide}
        fileid={getFileViewData}
      />
      {/* <VendorBulkUploadModalMR
        show={showBulkUpload}
        onHide={() => setShowBulkUpload(false)}
      /> */}
    </main>
  );
};

export default UserRegistrationListMR;
